
import type { DropdownMenuProps } from '@radix-ui/react-dropdown-menu';
import { useEditorRef, useSelectionFragmentProp } from '@udecode/plate/react';
import { setAlign } from '@udecode/plate-alignment';
import {
    AlignCenterIcon,
    AlignJustifyIcon,
    AlignLeftIcon,
    AlignRightIcon,
} from 'lucide-react';

import { STRUCTURAL_TYPES } from '../../utils/transforms.utils';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuTrigger,
    useOpenState,
} from '../common/dropdownMenu.component';
import { ToolbarButton } from '../common/toolbar.component';

const items = [
    {
        icon: AlignLeftIcon,
        value: 'left',
    },
    {
        icon: AlignCenterIcon,
        value: 'center',
    },
    {
        icon: AlignRightIcon,
        value: 'right',
    },
    {
        icon: AlignJustifyIcon,
        value: 'justify',
    },
];

export function AlignDropdownMenu({ ...props }: DropdownMenuProps) {
    const editor = useEditorRef();
    const value = useSelectionFragmentProp({
        defaultValue: 'justify',
        structuralTypes: STRUCTURAL_TYPES,
        getProp: (node) => node.align,
    });

    const openState = useOpenState();
    const IconValue =
    items.find((item) => item.value === value)?.icon ?? AlignLeftIcon;

    return (
        <DropdownMenu modal={false} {...openState} {...props}>
            <DropdownMenuTrigger asChild>
                <ToolbarButton pressed={openState.open} tooltip="Zarovnání textu" isDropdown>
                    <IconValue />
                </ToolbarButton>
            </DropdownMenuTrigger>

            <DropdownMenuContent className="min-w-0" align="start">
                <DropdownMenuRadioGroup
                    value={value}
                    onValueChange={(value: any) => {
                        setAlign(editor, { value: value });
                        editor.tf.focus();
                    }}
                >
                    {items.map(({ icon: Icon, value: itemValue }) => (
                        <DropdownMenuRadioItem key={itemValue} value={itemValue} hideIcon>
                            <Icon />
                        </DropdownMenuRadioItem>
                    ))}
                </DropdownMenuRadioGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
